import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingDataService {
  private _isLoadingData = new ReplaySubject<boolean>();

  private _loadingOtherData: boolean;
  private _loadingUserData: boolean;

  public loadingUserData(loadingState: boolean) {
    this._loadingUserData = loadingState;
    this._isLoadingData.next(this._loadingOtherData || this._loadingUserData);
  }

  public loadingOtherData(loadingState: boolean) {
    this._loadingOtherData = loadingState;
    this._isLoadingData.next(this._loadingOtherData || this._loadingUserData);
  }

  public getLoadingState(): ReplaySubject<boolean> {
    return this._isLoadingData;
  }
  constructor() {
    this._loadingOtherData = false;
    this._loadingUserData = true;
  }
}
